import { FormEvent, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { Button, Col, Form, Row } from "react-bootstrap"
import { getUrlSearchParams } from "../../../urlParams"
import { ApiEndpoints, reqGetNew, reqPatch, reqPostNew, reqPut } from "../../../../config/apiClient"
import removeAllErrorMsg from "../../../../components/funcRemoveAllErros"
import funcSleep from "../../../../components/funcSleep"
import LoadingModal from "../../../../components/loadingModal"
import { defineValueInInput } from "../../../../components/funcForInput"
import { iNfServicoMunDto } from "./NFSeServicosMunPage"
import Select from "react-select"

function NFSeServicosMunEditarPage() {
    const [loading, setLoading] = useState<boolean>(false)
    const [servicoDados, setTipoDados] = useState<iNfServicoMunDto | any>({})
    const [filtros, setFiltros] = useState<any>({ clientes: [], clientes_tipos: [], servicos: [], servicos_antigos: [], servicos_empresas: [], cidades: [], empresas: [] })
    const [cidadesFiltro, setCidadesFiltro] = useState<any[]>([])
    const [servicosFiltro, setServicosFiltro] = useState<any[]>([])
    const [permitirEdicao, setPermitirEdicao] = useState<boolean>(true)

    const choiceNaoSelecionado = { "value": "0", "label": "Não Selecionado" }
    const [codCidade, setCodCidade] = useState<any>(choiceNaoSelecionado)
    const [codServico, setCodServico] = useState<any>(choiceNaoSelecionado)

    useEffect(() => {
        document.title = "Cadastrar NFSe Serviço Municipal | OB PORTUS"

        definirCamposSelect()
        const urlDados = getUrlSearchParams()
        const id = urlDados.get("id")

        const getDados = async (id:number) => {
            setLoading(true)

            const dados = {
                id_servico: Number(id)
            }

            const api = await reqPostNew(ApiEndpoints.nfseServicoMunicipalConsultar, dados)

            if (api.status === 200) {
                const servico:iNfServicoMunDto = api.data
                setTipoDados(servico)
                const codCidadeAux = {
                    "value": `${servico.cidade_cod.cod_cidade}`,
                    "label": `${servico.cidade_cod.nome}/${servico.cidade_cod.uf}`
                }
                setCodCidade(codCidadeAux)
                const codServicoAux = {
                    "value": `${servico.servico_cod.servico_cod}`,
                    "label": `#${servico.servico_cod.servico_cod} ${servico.servico_cod.servico_descricao} - ${servico.servico_cod.tributos_situacao === 1 ? "Retido" : "Tributado"}`
                }
                setCodServico(codServicoAux)
                defineValueInInput('servico_cod_mun', servico.servico_cod_mun)
                defineValueInInput('servico_descricao', servico.servico_descricao)
                setPermitirEdicao(false)
            }

            setLoading(false)
        }

        if (id !== null) {
            getDados(Number(id))
            document.title = "Editar NFSe Serviço Municipal | OB PORTUS"
        }
        // eslint-disable-next-line
    }, [])

    async function definirCamposSelect() {
        const filtros = await getFiltros()
        let cidadesAux = filtros.cidades.map((item: any, index: any) => (
            {
                "value": `${item.cod_cidade}`,
                "label": `${item.nome}/${item.uf}`
            }
        ))
        setCidadesFiltro(cidadesAux)
        let servicosAux = filtros.servicos.map((item: any, index: any) => (
            {
                "value": `${item.servico_cod}`,
                "label": `#${item.servico_cod} ${item.servico_descricao} - ${item.tributos_situacao === 1 ? "Retido" : "Tributado"}`
            }
        ))
        setServicosFiltro(servicosAux)
    }
    async function getFiltros(): Promise<any> {
        const apiFiltros = await reqGetNew(ApiEndpoints.nfseFiltros)
        if (apiFiltros.status === 200) {
            const filtrosAux = {
                clientes: apiFiltros.data.clientes,
                clientes_tipos: apiFiltros.data.clientes_tipos,
                servicos: apiFiltros.data.servicos,
                servicos_antigos: apiFiltros.data.servicos_antigos,
                servicos_empresas: apiFiltros.data.servicos_empresas,
                cidades: apiFiltros.data.cidades,
                empresas: apiFiltros.data.empresas,
            }
            setFiltros(filtrosAux)
            return filtrosAux
        }
        return filtros
    }

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()

        removeAllErrorMsg()

        const form:any = event.target
        let formValidado = true

        let dados:iNfServicoMunDto = {
            id: Object.values(servicoDados).length === 0 ? null : servicoDados.id,
            cidade_cod: Number(codCidade.value),
            servico_cod: codServico.value,
            servico_cod_mun: form.servico_cod_mun.value,
            servico_descricao: form.servico_descricao.value,
        }

        if (dados.cidade_cod === 0) {
            form.cod_cidade_aux.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.servico_cod === "0") {
            form.cod_servico_aux.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.servico_cod_mun.length !== 3) {
            form.servico_cod_mun.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.servico_descricao === "") {
            form.servico_descricao.nextElementSibling.style.display = "block"
            formValidado = false
        }

        console.info(dados)

        if (!formValidado) {
            return
        }

        if (Object.values(servicoDados).length === 0) {
            cadastrar(dados)
        }

        if (Object.values(servicoDados).length > 0) {
            editar(dados)
        }
    
    }

    function redirecionarAposAlteracao() {
        window.location.assign(`/nfse/servicos_mun`)
    }
    async function cadastrar(dados:iNfServicoMunDto) {

        setLoading(true)

        const api = await reqPut(ApiEndpoints.nfseServicoMunicipalCadastrar, dados)

        if (api.status === 201) {
            console.log(api.data)

            toast.success('Serviço cadastrado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)
            redirecionarAposAlteracao()
            
        }
        setLoading(false)

    }
    async function editar(dados: iNfServicoMunDto) {
        setLoading(true)

        const api = await reqPatch(ApiEndpoints.nfseServicoMunicipalEditar, dados)

        if (api.status === 200) {
            console.log(api.data)

            toast.success('Serviço editado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)
            redirecionarAposAlteracao()
        }

        setLoading(false)
    }
    async function handleExcluirTipo() {
        if (!window.confirm('Tem certeza que deseja excluir o Serviço?')) {
            return
        }

        const dados = {
            id_servico: servicoDados.id
        }

        setLoading(true)

        const api = await reqPostNew(ApiEndpoints.nfseServicoMunicipalDeletar, dados)

        if (api.status === 200) {
            console.log(api.data)

            toast.success('Serviço excluído com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)
            redirecionarAposAlteracao()
        }

        setLoading(false)

    }
    
    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={(event:any) => {
                setLoading(!loading)
            }} />
            <div className="div-row-space-between">
            <h1 id="titleMain">NF Serviço Municipal</h1>
            <Button variant="secondary" onClick={() => {window.location.assign(`/nfse/servicos_mun`)}}>Voltar</Button>
            </div>
            <br></br>
            <Form id='formNfServicoMunicipal' onSubmit={handleSubmit} noValidate>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Cidade Serviço:</Form.Label>
                            <Select name='cod_cidade' id='cod_cidade' options={cidadesFiltro} value={codCidade} placeholder="Selecione a Cidade" onChange={
                                (choice: any) => {
                                    setCodCidade(choice)
                                }
                            } styles={customSelectStylesNfs} isDisabled={!permitirEdicao} />
                            <Form.Control name='cod_cidade_aux' type="text" id='cod_cidade_aux' placeholder="" style={{ display: "none" }} />
                            <Form.Control.Feedback type="invalid">
                                Informe a Cidade!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-6">
                        <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Serviço:</Form.Label>
                            <Select name='cod_servico' id='cod_servico' options={servicosFiltro} value={codServico} placeholder="Selecione o Serviço" onChange={
                                (choice: any) => {
                                    setCodServico(choice)
                                }
                            } styles={customSelectStylesNfs} isDisabled={!permitirEdicao} />
                            <Form.Control name='cod_servico_aux' type="text" id='cod_servico_aux' placeholder="" style={{ display: "none" }} />
                            <Form.Control.Feedback type="invalid">
                                Informe o Serviço!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Código:</Form.Label>
                            <Form.Control name='servico_cod_mun' type="text" id='servico_cod_mun' placeholder="" maxLength={3} disabled={!permitirEdicao} autoComplete="off" />
                            <Form.Control.Feedback type="invalid">
                                O código precisa ser composto por 3 dígitos!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-6">
                        <Form.Group>
                            <Form.Label>Descrição:</Form.Label>
                            <Form.Control name='servico_descricao' type="text" id='servico_descricao' placeholder="" autoComplete="off" />
                            <Form.Control.Feedback type="invalid">
                                Informe o Descrição!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    
                </Row>

                {
                    Object.values(servicoDados).length === 0 &&
                    <Button variant="success" type="submit" disabled={loading}>{loading ? 'Aguarde ...' : 'Cadastrar'}</Button>
                }

                {
                    Object.values(servicoDados).length > 0 &&
                    <Button variant="success" type="submit" disabled={loading} style={{marginRight: '10px'}}>{loading ? 'Aguarde ...' : 'Editar'}</Button>
                }

                {
                    Object.values(servicoDados).length > 0 &&
                    <Button variant="danger" disabled={loading} style={{marginRight: '10px'}} onClick={() => {handleExcluirTipo()}}>{loading ? 'Aguarde ...' : 'Deletar'}</Button>
                }
            </Form>
        </div>
    )
}

export default NFSeServicosMunEditarPage

const customSelectStylesNfs = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        borderColor: "#dee2e6",
        backgroundColor: state.isDisabled ? "#E9ECEF" : "white",
    }),
    singleValue: (provided: any, state: any) => ({
        ...provided,
        color: state.isDisabled ? "black" : "black",
    }),
}
